import { useTranslation } from "react-i18next";

import { asRequestStatus, type RequestStatus } from "../model/types";

/** Figma: `Badge` (11:106). Цвет статуса — из семейств profit/loss/warning. */
const TONES: Record<RequestStatus, string> = {
  pending: "bg-surface-muted text-status-warning",
  approved: "bg-surface-profit text-status-profit",
  paid: "bg-surface-profit text-status-profit",
  rejected: "bg-surface-loss text-status-loss",
};

export function RequestStatusBadge({ status }: { status: string }) {
  const { t } = useTranslation();
  const value = asRequestStatus(status);

  return (
    <span
      className={`inline-flex items-center rounded-full px-2.5 py-1 text-micro font-semibold uppercase ${TONES[value]}`}
    >
      {t(`wallet.requestStatus.${value}`)}
    </span>
  );
}
